const NS_MAPS = 'cisview_job_';

export const SET_GLOBAL_JOB_STATUS = `${NS_MAPS}SET_GLOBAL_JOB_STATUS`;
export const setGlobalJobStatus = status => {
	return {
		type: SET_GLOBAL_JOB_STATUS,
		payload: { status }
	};
};
